import DocumentsAPI from './documents';

// Project-scoped file-document singleton.
export default new DocumentsAPI('projects');
